<script>
export default {
  methods: {
    async printDanfe() {
      let resourceApi = 'nfe/danfe';

      if (this.productInvoiceSelected.model == this.$enums.modelNf.NFCE) {
        resourceApi = 'nfce/danfce';
      }

      this.$api.productInvoices
        .danfe(
          this.productInvoiceSelected.id,
          this.productInvoiceSelected.model
        )
        .then(() => {
          const urlBaseWeb = import.meta.env.VITE_URL_WEB_K8S;
          window.open(
            `${urlBaseWeb}/${resourceApi}/${this.productInvoiceSelected.key_nfe}`
          );
        });
    },
    async downloadDanfe() {
      let resourceApi = 'nfe/danfe-download';

      if (this.productInvoiceSelected.model == this.$enums.modelNf.NFCE) {
        resourceApi = 'nfce/danfce-download';
      }
      this.$api.productInvoices
        .danfe(
          this.productInvoiceSelected.id,
          this.productInvoiceSelected.model
        )
        .then(() => {
          const urlBaseWeb = import.meta.env.VITE_URL_WEB_K8S;
          window.open(
            `${urlBaseWeb}/${resourceApi}/${this.productInvoiceSelected.key_nfe}`
          );
        });
    },
  },
};
</script>
